'use strict';

var _ = require('lodash');
var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/configClone/DNARecord/StaticDNARecordForm.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of an individual DNA entry.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/configClone/FormView#model
   * @type {actions/configClone/ConfigClone}
   */

  template: twig({data: tpl}),

  templateContext: function() {
    var baseHelpers = BaseStaticView.prototype.templateContext.apply(this);

    return _.extend({}, baseHelpers);
  },
});
